import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import MockDate from "mockdate";
import { connect } from "react-redux";
import { change, stopSubmit, touch } from "redux-form";
import { graphql, gql, compose } from "react-apollo";
import { injectIntl, FormattedMessage } from "react-intl";
import { Field, formValueSelector } from "redux-form";
import { DateUtils } from "react-day-picker";
import Button from "react-bootstrap/lib/Button";
import FormGroup from "react-bootstrap/lib/FormGroup";
import Col from "react-bootstrap/lib/Col";
import FormControl from "react-bootstrap/lib/FormControl";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "!isomorphic-style-loader!css-loader!./DayDragCalendar.css";

import Loader from "../Loader";
import AvailableDates from "./AvailableDates";
import DateRange from "./DateRange";
import { getListingDataStep3 } from "../../actions/getListingDataStep3";
import { getListBlockedDates } from "../../actions/Listing/getListBlockedDates";
import { manageListingSteps } from "../../actions/manageListingSteps";
import { getDateUsingTimeZone } from "../../helpers/dateRange";
import showToaster from "../../helpers/showToaster";
import messages from "../../locale/messages";
import c from "./SaveCalendar.css";
import bt from "../commonStyle.css";
import { ControlLabel } from "react-bootstrap";
import InputFieldComponent from "../Common/FormField/InputFieldComponent";
import { bindActionCreators } from "redux";
import { containsMalicious } from "../../helpers/textRestriction";
class SaveCalendar extends Component {
  static propTypes = {
    change: PropTypes.func,
    formName: PropTypes.string,
    selectedDays: PropTypes.array,
    start: PropTypes.any,
    end: PropTypes.any,
  };

  static defaultProps = {
    selectedDays: [],
    start: undefined,
    end: undefined,
    formName: "ListPlaceStep3",
    formNameValue: "CalendarPrice",
    isCurrentStatus: 2,
    isEditMode: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      dateRange: [],
      isLoading: false,
    };
    this.chooseDates = this.chooseDates.bind(this);
  }

  componentDidMount() {
    this.setState({ isCurrentStatus: 2 });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { start, end } = nextProps;
    let dateRange = [],
      rangeStart,
      rangeEnd;

    if (start && !end) {
      rangeStart = new Date(start);
      dateRange.push(rangeStart);
    } else if (start && end) {
      rangeStart = new Date(start);
      rangeEnd = new Date(end);

      if (!DateUtils.isSameDay(rangeStart, rangeEnd)) {
        dateRange.push(rangeStart);

        rangeStart = new Date(+rangeStart);

        while (rangeStart < end) {
          dateRange.push(rangeStart);
          var newDate = rangeStart.setDate(rangeStart.getDate() + 1);
          rangeStart = new Date(newDate);
        }
      }
    }
    this.setState({ dateRange });
  }

  renderFormControl = ({
    input,
    label,
    type,
    meta: { touched, error },
    className,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
        <FormControl
          {...input}
          placeholder={label}
          type={type}
          className={className}
          maxLength={3}
        />
      </div>
    );
  };

  renderDateRange = ({
    input,
    label,
    meta: { touched, error },
    formName,
    numberOfMonths,
    index,
    defaultStartDate,
    defaultEndDate,
    isCurrentStatus,
    resetCalendar,
    startLabel,
    endLabel,
    onDateSelect,
  }) => {
    const { formatMessage } = this.props.intl;
    const { locale } = this.props;
    let localeData = "en-US";
    if (locale == "ar-AR") {
      localeData = "ar-AR";
      moment.locale("ar-AR");
    }

    return (
      <div className={"saveCalenderDate"}>
        <DateRange
          {...input}
          formName={formName}
          numberOfMonths={numberOfMonths}
          index={index}
          defaultStartDate={defaultStartDate}
          defaultEndDate={defaultEndDate}
          isCurrentStatus={isCurrentStatus}
          resetCalendar={resetCalendar}
          startDatePlaceholderText={startLabel}
          endDatePlaceholderText={endLabel}
          onDateSelect={onDateSelect}
        />
        {touched && error && (
          <span className={c.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  async handleSave() {
    const { guestName, note, dispatch, formName, isStartDate, isEndDate } =
      this.props;

    // 1. Validate inputs
    const validationErrors = this.validateInputs({ guestName, note });
    // ✅ Check: End Date is required if Start Date exists
    if (isStartDate && !isEndDate) {
      validationErrors.blockedDates = messages.endDateRequired;
    }
    if (Object.keys(validationErrors).length > 0) {
      dispatch(touch(formName, ...Object.keys(validationErrors)));
      dispatch(stopSubmit(formName, validationErrors));
      this.setState({ isLoading: false });
      return;
    }

    this.setState({ isLoading: true });

    // 2. Prepare date ranges
    const dateRangeNew = this.getDateRange();

    // 3. Perform API mutation and post actions
    await this.saveBlockedDates(dateRangeNew);

    this.setState({ isLoading: false });
    this.setState({ isEditMode: false });
  }

  // Validation helper
  validateInputs({ guestName, note }) {
    const validationErrors = {};

    if (containsMalicious(guestName)) {
      validationErrors.guestName = messages.invalidInput;
    }
    if (guestName && guestName.trim().length > 255) {
      validationErrors.guestName = messages.guestNameLimit;
    }

    if (containsMalicious(note)) {
      validationErrors.note = messages.invalidInput;
    }

    return validationErrors;
  }

  // Date range helper
  getDateRange() {
    const { isStartDate, isEndDate } = this.props;
    const dateRangeNew = [];

    if (isStartDate && !isEndDate) {
      dateRangeNew.push(new Date(isStartDate));
    } else if (isStartDate && isEndDate) {
      let rangeStart = new Date(isStartDate);
      const rangeEnd = new Date(isEndDate);

      if (!DateUtils.isSameDay(rangeStart, rangeEnd)) {
        dateRangeNew.push(rangeStart);
        rangeStart = new Date(+rangeStart);

        while (rangeStart < rangeEnd) {
          dateRangeNew.push(rangeStart);
          const newDate = rangeStart.setDate(rangeStart.getDate() + 1);
          rangeStart = new Date(newDate);
        }
      }
    }

    return dateRangeNew;
  }

  // API mutation and post-processing helper
  async saveBlockedDates(dateRangeNew) {
    const {
      selectedDays,
      listId,
      mutate,
      change,
      getListingDataStep3,
      getListBlockedDates,
      resetCalendar,
      minNight,
      maxNight,
      checkInEnd,
      checkInStart,
      houseRules,
      cancellationPolicy,
      maxDaysNotice,
      bookingNoticeTime,
      basePrice,
      cleaningPrice,
      currency,
      tax,
      weeklyDiscount,
      monthlyDiscount,
      country,
      intl: { formatMessage },
    } = this.props;

    let updatedSelectedDays = [...selectedDays];
    let propertyToday = getDateUsingTimeZone(country, true);

    if (propertyToday != null) {
      MockDate.set(propertyToday);
    }

    // Add new dates not already selected
    dateRangeNew.forEach((item) => {
      const exists = updatedSelectedDays.some((selectedDay) =>
        DateUtils.isSameDay(selectedDay, item)
      );
      if (!exists) updatedSelectedDays.push(item);
    });

    MockDate.reset();

    if (!dateRangeNew.length) return;

    const minNightValues = minNight || 0;
    const maxNightValues = maxNight || 0;
    const checkInEndValue = checkInEnd || "flexible";
    const checkInStartValue = checkInStart || "flexible";
    const isCancel = cancellationPolicy || "1";
    const isMaxDays = maxDaysNotice || "unavailable";
    const isBooking = bookingNoticeTime || 58;

    const { data } = await mutate({
      variables: {
        listId,
        blockedDates: updatedSelectedDays,
        calendarStatus: "blocked",
        guestName: this.props.guestName || null,
        note: this.props.note || null,
      },
    });

    if (
      data &&
      data.UpdateBlockedDates &&
      data.UpdateBlockedDates.status == "200"
    ) {
      await change("blockedDates", updatedSelectedDays);
      await getListingDataStep3(listId);
      await getListBlockedDates(
        listId,
        minNightValues,
        maxNightValues,
        checkInEndValue,
        checkInStartValue,
        houseRules,
        isCancel,
        isMaxDays,
        isBooking,
        basePrice,
        cleaningPrice,
        currency,
        tax,
        weeklyDiscount,
        monthlyDiscount
      );
      await getListingDataStep3(listId);
      await resetCalendar();
    } else {
      showToaster({
        messageId: "commonError",
        toasterType: "error",
        requestContent: formatMessage(messages.selectedDatesError),
      });
    }
  }

  chooseDates(type) {
    const { dispatch } = this.props;
    this.setState(
      {
        isCurrentStatus: type,
      },
      () => {
        if (type === 2) {
          // 2 means Available
          const { change, formName } = this.props;
          change(formName, "guestName", null);
          change(formName, "note", null);
          dispatch(stopSubmit(formName, { blockedDates: undefined }));
        }
      }
    );
  }
  handleEdit = () => {
    const { blockDategroups, change, formName } = this.props;
    const { blockedDate } = blockDategroups?.at(0);

    this.setState({ isEditMode: true }, () => {
      change(formName, "guestName", blockedDate?.guestName || "");
      change(formName, "note", blockedDate?.note || "");
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { blockDategroups, change, formName, start, isStartDate } =
      this.props;

    // Case 1: unselect — disable edit mode and clear
    const dateUnselected =
      prevProps.blockDategroups.length === 1 &&
      blockDategroups.length !== 1 &&
      this.state.isEditMode;

    if (dateUnselected) {
      this.setState({ isEditMode: false });
      change(formName, "guestName", null);
      change(formName, "note", null);
    }
    // Case 2: popup just opened and selected date is blank (not blocked)
    const popupOpenedNow =
      !(prevProps.start || prevProps.isStartDate) && (start || isStartDate);

    if (popupOpenedNow) {
      this.setState({ isEditMode: false });
      change(formName, "guestName", null);
      change(formName, "note", null);
    }
  }
  render() {
    const {
      selectedDays,
      start,
      end,
      formName,
      resetCalendar,
      listId,
      resetDatePickerChange,
      blockDategroups,
      onDateSelect,
    } = this.props;
    const { formatMessage } = this.props.intl;
    const { minNight, maxNight, houseRules, checkInEnd, checkInStart } =
      this.props;
    const {
      cancellationPolicy,
      maxDaysNotice,
      bookingNoticeTime,
      isStartDate,
      isEndDate,
    } = this.props;
    const {
      basePrice,
      cleaningPrice,
      currency,
      tax,
      weeklyDiscount,
      monthlyDiscount,
    } = this.props;
    const { isCurrentStatus } = this.state;

    const { dateRange, isLoading } = this.state;
    let convertStart = start ? moment(start).format("YYYY-MM-DD") : null;
    let convertEnd = end ? moment(end).format("YYYY-MM-DD") : null;
    let isBlock = 1,
      isAvailable = 2;
    return (
      <div>
        {(start || isStartDate) && (
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className={cx(c.saveCalendarContainer, c.CalendarPopup)}
          >
            <div className={c.innerCPopup}>
              <FormGroup className={cx(c.formGroup, c.textLeft, c.px15)}>
                <Button
                  bsStyle="link"
                  className={cx(c.noPadding, c.space3, "saveCalendarDark")}
                  onClick={() => {
                    resetCalendar();
                    this.setState({ isEditMode: false });
                  }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    role="img"
                    style={{
                      height: "14px",
                      width: "14px",
                      display: "block",
                      fill: "rgb(118, 118, 118)",
                    }}
                  >
                    <path d="m23.25 24c-.19 0-.38-.07-.53-.22l-10.72-10.72-10.72 10.72c-.29.29-.77.29-1.06 0s-.29-.77 0-1.06l10.72-10.72-10.72-10.72c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l10.72 10.72 10.72-10.72c.29-.29.77-.29 1.06 0s .29.77 0 1.06l-10.72 10.72 10.72 10.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22"></path>
                  </svg>
                </Button>
              </FormGroup>
              <div className={cx(c.aBlockWrap, c.mx15, "bgBlackTwo")}>
                <div className={c.aBWLeft}>
                  <Button
                    className={cx(
                      c.btnBg,
                      { [c.active]: isCurrentStatus == 2 },
                      c.leftRadius,
                      "bgBlackTwo"
                    )}
                    onClick={() => this.chooseDates(isAvailable)}
                  >
                    <FormattedMessage {...messages.availableLabel} />
                  </Button>
                </div>
                <div className={c.aBWRight}>
                  <Button
                    className={cx(
                      c.btnBg,
                      { [c.active]: isCurrentStatus == 1 },
                      c.rightRadius,
                      "bgBlackTwo"
                    )}
                    onClick={() => this.chooseDates(isBlock)}
                  >
                    <FormattedMessage {...messages.blockLabel} />
                  </Button>
                </div>
              </div>
              <div className={cx(c.saveBorder, c.mx15)}>
                <div className={c.datesBorder}>
                  <FormGroup className={cx(c.formGroup, c.sDateWrap)}>
                    <label>
                      <FormattedMessage {...messages.dates} />
                    </label>
                  </FormGroup>
                  <FormGroup className={c.noMargin}>
                    <Field
                      name="blockedDates"
                      component={this.renderDateRange}
                      defaultStartDate={start}
                      defaultEndDate={end}
                      formName={formName}
                      isCurrentStatus={isCurrentStatus}
                      resetCalendar={resetDatePickerChange}
                      startLabel={formatMessage(messages.StartDate)}
                      endLabel={formatMessage(messages.EndDate)}
                      onDateSelect={onDateSelect}
                    />
                  </FormGroup>
                </div>
                {isCurrentStatus == 2 && (
                  <AvailableDates
                    start={start}
                    end={end}
                    listId={listId}
                    selectedDays={selectedDays}
                    resetCalendar={resetCalendar}
                    dateRange={dateRange}
                    minNight={minNight}
                    maxNight={maxNight}
                    houseRules={houseRules}
                    checkInEnd={checkInEnd}
                    checkInStart={checkInStart}
                    cancellationPolicy={cancellationPolicy}
                    maxDaysNotice={maxDaysNotice}
                    bookingNoticeTime={bookingNoticeTime}
                    cleaningPrice={cleaningPrice}
                    basePrice={basePrice}
                    currency={currency}
                    isStartDate={isStartDate}
                    isEndDate={isEndDate}
                    tax={tax}
                    weeklyDiscount={weeklyDiscount}
                    monthlyDiscount={monthlyDiscount}
                  />
                )}
              </div>
              {isCurrentStatus == 1 && (
                <>
                  <div className={c.calenderLine}></div>

                  {blockDategroups?.length !== 1 ||
                  this.state.isEditMode ||
                  (blockDategroups?.length === 1 &&
                    !blockDategroups?.at(0)?.blockedDate?.guestName &&
                    !blockDategroups?.at(0)?.blockedDate?.note) ? (
                    <div className={c.px15}>
                      <FormGroup className={cx(s.formGroup, c.noMargin)}>
                        <ControlLabel className={cx(s.landingLabel)}>
                          <FormattedMessage {...messages.guestName} />
                        </ControlLabel>

                        <Field
                          name="guestName"
                          type="text"
                          component={InputFieldComponent}
                          placeholder={formatMessage(messages.enterGuestName)}
                          className={cx(s.formControlInput, s.jumboInput)}
                        />
                      </FormGroup>
                      <FormGroup className={cx(s.formGroup, c.noMargin)}>
                        <ControlLabel className={cx(s.landingLabel)}>
                          <FormattedMessage {...messages.note} />
                        </ControlLabel>
                        <Field
                          name="note"
                          type="textarea"
                          component={InputFieldComponent}
                          componentClass={"textarea"}
                          placeholder={formatMessage(messages.enterNote)}
                          className={cx(
                            s.formControlInput,
                            s.jumboInput,
                            c.noteText
                          )}
                        />
                      </FormGroup>
                    </div>
                  ) : (
                    <div className={c.px15}>
                      <ControlLabel className={cx(s.landingLabel)}>
                        <FormattedMessage {...messages.blockedFor} />
                      </ControlLabel>
                      {blockDategroups?.at(0)?.blockedDate?.guestName && (
                        <div>
                          <div className={c.guestName}>
                            {blockDategroups?.at(0)?.blockedDate?.guestName ||
                              ""}
                          </div>
                        </div>
                      )}
                      {blockDategroups?.at(0)?.blockedDate?.note && (
                        <div className={c.note}>
                          <p>
                            {" "}
                            {blockDategroups?.at(0)?.blockedDate?.note || ""}
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {isCurrentStatus == 1 && (
                <>
                  {blockDategroups?.length === 1 &&
                    (blockDategroups?.at(0)?.blockedDate?.guestName !== null ||
                      blockDategroups?.at(0)?.blockedDate?.note !== null) &&
                    !this.state.isEditMode && (
                      <Button
                        className={cx(
                          c.btnPrimaryBorder,
                          c.btnlarge,
                          c.buttonRight,
                          c.editBtn
                        )}
                        onClick={() => {
                          this.handleEdit();
                        }}
                      >
                        <FormattedMessage {...messages.edit} />
                      </Button>
                    )}
                  <FormGroup
                    className={cx(
                      c.formGroup,
                      c.buttonLeft,
                      "saveRightRtl",
                      "arButtonLoader",
                      c.mx15
                    )}
                  >
                    <Loader
                      type={"button"}
                      buttonType={"button"}
                      show={isLoading}
                      className={cx(
                        c.btnPrimary,
                        c.btnlarge,
                        bt.btnSecondary,
                        c.saveBg
                      )}
                      disabled={isLoading}
                      label={formatMessage(messages.blockDates)}
                      handleClick={() => {
                        this.handleSave();
                      }}
                      containerClass={cx(c.loaderContainer, "calBtnRtl")}
                    />
                  </FormGroup>
                </>
              )}

              <Button
                className={cx(c.btnPrimaryBorder, c.btnlarge, c.buttonRight)}
                onClick={() => {
                  resetCalendar();
                  this.setState({ isEditMode: false });
                }}
              >
                <FormattedMessage {...messages.deSelect} />
              </Button>
              <div className="clearBoth"></div>
            </div>
          </Col>
        )}
      </div>
    );
  }
}

const step1FormSelector = formValueSelector("ListPlaceStep1");
const step3FormSelector = formValueSelector("ListPlaceStep3");

const mapState = (state) => ({
  locale: state.intl.locale,
  country: step1FormSelector(state, "country"),
  guestName: step3FormSelector(state, "guestName"),
  note: step3FormSelector(state, "note"),
});

const mapDispatch = (dispatch) => ({
  dispatch, // ✅ manual injection for raw dispatch
  ...bindActionCreators(
    {
      change,
      getListingDataStep3,
      getListBlockedDates,
      manageListingSteps,
    },
    dispatch
  ),
});
export default compose(
  injectIntl,
  withStyles(s, c, bt),
  connect(mapState, mapDispatch),
  graphql(gql`
    mutation (
      $listId: Int!
      $blockedDates: [String]
      $calendarStatus: String
      $guestName: String
      $note: String
    ) {
      UpdateBlockedDates(
        listId: $listId
        blockedDates: $blockedDates
        calendarStatus: $calendarStatus
        guestName: $guestName
        note: $note
      ) {
        status
      }
    }
  `)
)(SaveCalendar);
